import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

const EmailInput = ({ input, label, meta: { error } }) =>
  (<TextField
    {...input}
    floatingLabelText={label}
    errorText={error}
    type="email"
    fullWidth
  />);

EmailInput.defaultProps = {
  label: '',
};

EmailInput.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  label: PropTypes.node,
};

export default EmailInput;



// WEBPACK FOOTER //
// ./src/components/form/EmailInput.js